import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import ProtectedLayout from "../User/ProtectedLayout";
import Logo from "../User/Logo";
import SidebarItem from "../User/SidebarItem";
import Header from "../User/Header";
import { ToastContainer } from "react-toastify";
import AdminBottomNav from "./BottomNav";

const AdminLayout = () => {

    const profile = useSelector((state) => state.auth.profile);

    if (profile && profile?.role && profile?.role !== "admin") {
        return <Navigate to="/" replace />;
    }

    const menu = [
        {
            title: "داشبورد",
            path: "/admin",
            icon: "/assets/images/icons/home.svg",
        },
        {
            title: "قرار‌ها",
            path: "/admin/appointments",
            icon: "/assets/images/icons/time.svg",
        },
        {
            title: "پرداخت‌ها",
            path: "/admin/payments",
            icon: "/assets/images/icons/wallet.svg",
        },
        {
            title: "کارکنان سالن",
            path: "/admin/staff",
            icon: "/assets/images/icons/staff-card.svg",
        },
        {
            title: "خدمات سالن",
            path: "/admin/services",
            icon: "/assets/images/icons/plans-king.svg",
        },
        {
            title: "تعطیلات عمومی سالن",
            path: "/admin/holidays",
            icon: "/assets/images/icons/empty.svg",
        },
        {
            title: "کاربران",
            path: "/admin/users",
            icon: "/assets/images/icons/emoji.svg",
        },
        {
            title: "پروفایل کاربری من",
            path: "/admin/profile",
            icon: "/assets/images/icons/user-2.svg",
        },
    ];

    return (
        <ProtectedLayout>

            <div className="flex min-h-screen bg-slate-100">

                {/* Sidebar desktop */}
                <aside className="hidden md:flex flex-col w-64 bg-white shadow-lg p-5 shrink-0">

                    <div className="sticky top-4">

                        <Logo />

                        <nav className="flex flex-col gap-4 mt-10">
                            {menu.map((item) => (
                                <SidebarItem key={item.path} item={item}/>
                            ))}
                        </nav>
                    
                    </div>

                </aside>


                {/* Main section */}
                <div className="flex-1 flex flex-col">

                    <Header />

                    <main className="flex-1 p-4 md:p-8 pb-20 md:pb-8">
                        <div className="bg-white rounded-2xl shadow-custom-md p-4 py-6 md:py-8 md:p-6 min-h-[400px]">
                            <Outlet />
                        </div>
                    </main>

                </div>


                {/* Mobile Bottom Nav */}
                <AdminBottomNav />

                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    rtl
                />

            </div>

        </ProtectedLayout>
    );
};

export default AdminLayout;